export class Drug {
  id: string;
  CommonName: string;
}
